const quantidade_minima_de_avaliacoes = [
  {
    path: "/regime-param-av-compo",
    redirect: "",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      allowedPermissions: ["regime_param_av_compo_list"],
      breadCrumb: "Informações Acadêmicas - Manutenção de Regimento Escolar",
    },
    children: [
      {
        path: "/regime-param-av-compo/:regimentoEscolarId",
        name: "regime_param_av_compo",
        meta: {
          allowedPermissions: ["regime_param_av_compo_list"],
        },
        component: () =>
          import(
            "@/views/QuantidadeMinimaDeAvaliacao/QuantidadeMinimaDeAvaliacaoHome.vue"
          ),
      },
      {
        path: "/regime-param-av-compo/novo/:regimentoEscolarId",
        name: "regime_param_av_compo_novo",
        meta: {
          allowedPermissions: ["regime_param_av_compo_insert"],
        },
        component: () =>
          import(
            "@/views/QuantidadeMinimaDeAvaliacao/QuantidadeMinimaDeAvaliacaoCad.vue"
          ),
      },
      {
        path: "/regime-param-av-compo/editar/:regimentoEscolarId/:id",
        name: "regime_param_av_compo_editar",
        meta: {
          allowedPermissions: ["regime_param_av_compo_update"],
        },
        component: () =>
          import(
            "@/views/QuantidadeMinimaDeAvaliacao/QuantidadeMinimaDeAvaliacaoEdit.vue"
          ),
      },
    ],
  },
];

export { quantidade_minima_de_avaliacoes };
